import React from 'react'
import 'regenerator-runtime/runtime'
import {
  getAllBlogPosts,
  getBlogCategories,
  getFeaturedPost,
  getHomepageMetaTags
} from '../../../queries/blog'
import Blog from '../../../routes/Blog'
import Head from 'next/head'
import NotFoundPage from '../../../routes/404'
import { logEvent } from '../../../utils/firebase'

const Routes = ({ category, categories, featuredPost, meta, data }) => {
  if (!category) return <NotFoundPage />

  const content = category.attributes

  const tags = content.meta

  const twitterTags = tags?.metaSocial?.find(
    item => item.socialNetwork === 'Twitter'
  )
  const fbTags = tags?.metaSocial?.find(
    item => item.socialNetwork === 'Facebook'
  )

  return (
    <>
      <Head>
        <title>{tags.metaTitle}</title>
        <meta name="description" content={tags.metaDescription} />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:site"
          content={`https://www.decormatters.com/blog`}
        />
        <meta name="twitter:title" content={tags.metaTitle} />
        <meta
          name="twitter:image"
          content={
            twitterTags?.image?.data?.attributes?.url ||
            tags?.metaImage?.data?.attributes?.url
          }
        />
        <meta name="twitter:site" content="@decormattersapp" />
        <meta property="og:url" content={`https://www.decormatters.com/blog`} />
        <meta property="og:title" content={tags.metaTitle} />
        <meta property="og:description" content={tags.metaDescription} />
        <meta
          property="og:image"
          content={
            fbTags?.image?.data?.attributes?.url ||
            tags?.metaImage?.data?.attributes?.url
          }
        />
        <meta property="og:site_name" content="DecorMatters" />
      </Head>
      <Blog
        featuredPost={featuredPost.data[0]}
        activeCategory={category.id}
        categories={categories}
        pagination={meta.pagination}
        content={data}
      />
    </>
  )
}

export default Routes

export async function getServerSideProps({ query, req, res }) {
  try {
    const { categorySlug } = query

    const featuredPost = await getFeaturedPost()
    const categories = await getBlogCategories()
    const category = categories.data.find(
      item => item.attributes.slug === categorySlug
    )

    if (!category) return { props: {} }

    const content = await getAllBlogPosts({
      category: category?.id,
      page: query.page
    })

    res.setHeader(
      'Cache-Control',
      'public, s-maxage=3600, stale-while-revalidate=59'
    )

    return {
      props: {
        ...content,
        category,
        categories,
        featuredPost
      }
    }
  } catch (error) {
    console.log(error)

    logEvent('blog_category_error', {
      query,
      error
    })

    return {
      props: {}
    }
  }
}
